// React
import React from 'react'
import PropTypes from 'prop-types'

// Appt
import Text from '../../simple/text/Text.js'

// Font Awesome
import FontAwesome from '../fontAwesome/FontAwesome.js'

import styled from 'styled-components'
import { Button } from 'grommet'

let mainColor = '#ff8300'
let secondaryColor = '#04124C'

let StyledButtonSecondary = styled(Button)`

    background: ${secondaryColor} !important;
    color: ${mainColor} !important;

    border: 3px solid ${secondaryColor} !important;
    border-radius: 8px;
    padding: 8px 16px !important;
    span: {
        border-radius: 8px;
    }
    &:hover {
        border: 3px solid ${secondaryColor} !important;
        color: ${secondaryColor} !important;
        background: ${mainColor} !important;
        
    }
`  
let StyledButtonPrimary = styled(Button)`

    background: ${mainColor} !important;
    color: ${secondaryColor} !important;

    border: 3px solid ${mainColor} !important;
    border-radius: 8px;
    padding: 8px 16px !important;
    span: {
        border-radius: 8px;
    }
    &:hover {
        border: 3px solid ${mainColor} !important;
        color: ${mainColor} !important;
        background: ${secondaryColor} !important;
        
    }
`  

let StyledButtonPrimarySmall = styled(Button)`

    background: ${mainColor} !important;
    color: ${secondaryColor} !important;

    border: 3px solid ${mainColor} !important;
    border-radius: 8px;
    padding: 4px 8px !important;
    span: {
        border-radius: 8px;
    }
    &:hover {
        border: 3px solid ${mainColor} !important;
        color: ${mainColor} !important;
        background: ${secondaryColor} !important;
        
    }
`  

const StyledButtonPlain = styled(Button)`
    background: none !important;
    color: ${mainColor} !important;
    border: none !important;
    padding: 0 !important;
    span: {
        border-radius: 0;
        padding: 0 !important;
    }
    &:hover {
        background: none !important;
        color: ${mainColor} !important;
        border: none !important;
    }
`  

/**
 * `Small` renders a Card to display a counter of items eg. number of posts
 */
class ActionButton extends React.Component {

  render () {

    // let mainColor = '#ff8300'
    // let secondaryColor = '#04124C'

    // if (this.props?.secondary) {
    //     mainColor = '#04124C'
    //     secondaryColor = '#ff8300'
    // }

    let StyledButton = StyledButtonPrimary
    if (this.props?.secondary) {
        StyledButton = StyledButtonSecondary
    }
    if (this.props?.plain) {
        StyledButton = StyledButtonPlain
    }
    if (this.props?.small && this.props?.primary) {
        StyledButton = StyledButtonPrimarySmall
    }
    

    let labelIcon = this.props?.labelIcon
    let hasIcon = this.props?.labelIcon ? true : false

    let doOnClick = () => {
      if (!this?.props?.active && this.props?.onClick) {
        this.props.onClick()
      } else if (this?.props?.href) {
        window.open(this?.props?.href, '_self')
      }
    }

    let label = (<Text size='medium'>{labelIcon?.length > 0 && <FontAwesome icon={labelIcon} style={{ marginRight: '4px' }} />} {this.props?.label}</Text>)
    if (this.props?.children) {
        label = undefined
    }   

    let props = {}

    let keysToAllow = ['children', 'plain', 'type', 'style', 'sx', 'margin', 'pad']

    keysToAllow.forEach((key) => {
        if (this.props[key] !== undefined) {
            props[key] = this.props[key]
        }
    })



    return (
        <StyledButton   
            animation='fadeIn'
            active={this.props?.active}
            round="medium"
            label={label} 
            margin={{ horizontal: 'xsmall' }} 
            pad={{ horizontal: 'xsmall' }} 
            onClick={() => doOnClick()} target='_self' 
            type={this.props?.type || 'button'}
            {...props}
        />
    )
  }
}


ActionButton.propTypes = {
    /** 
     * Whether the button is primary styled
     */
    primary: PropTypes.bool,

    /**
     * Whether the button is secondary styled
     */
    secondary: PropTypes.bool,

    /** 
     * The label for the button
     */
    label: PropTypes.string,


    /** 
     * Whether the button is active, used to "disable" the button styling and onClick
    */
    active: PropTypes.bool,

    /** 
     * The function to call on click
     */
    onClick: PropTypes.func,

    /**  
     * The URL to navigate to when the button is clicked
    */
    href: PropTypes.string,

    /**
     * The icon displayed on the card
    */
    icon: PropTypes.array,
    /**
     * The FontAwesome weight for the icon
    */
    iconWeight: PropTypes.string,
}


export default ActionButton
